import axios from 'axios';
import {
  parseHeaderForLinks,
  loadMoreDataWhenScrolled,
  ICrudGetAction,
  ICrudGetAllAction,
  ICrudPutAction,
  ICrudDeleteAction,
} from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IYoutubeLiveVideo, defaultValue } from 'app/shared/model/youtube-live-video.model';

export const ACTION_TYPES = {
  FETCH_YOUTUBELIVEVIDEO_LIST: 'youtubeLiveVideo/FETCH_YOUTUBELIVEVIDEO_LIST',
  FETCH_YOUTUBELIVEVIDEO: 'youtubeLiveVideo/FETCH_YOUTUBELIVEVIDEO',
  CREATE_YOUTUBELIVEVIDEO: 'youtubeLiveVideo/CREATE_YOUTUBELIVEVIDEO',
  UPDATE_YOUTUBELIVEVIDEO: 'youtubeLiveVideo/UPDATE_YOUTUBELIVEVIDEO',
  DELETE_YOUTUBELIVEVIDEO: 'youtubeLiveVideo/DELETE_YOUTUBELIVEVIDEO',
  RESET: 'youtubeLiveVideo/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IYoutubeLiveVideo>,
  entity: defaultValue,
  links: { next: 0 },
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type YoutubeLiveVideoState = Readonly<typeof initialState>;

// Reducer

export default (state: YoutubeLiveVideoState = initialState, action): YoutubeLiveVideoState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_YOUTUBELIVEVIDEO_LIST):
    case REQUEST(ACTION_TYPES.FETCH_YOUTUBELIVEVIDEO):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_YOUTUBELIVEVIDEO):
    case REQUEST(ACTION_TYPES.UPDATE_YOUTUBELIVEVIDEO):
    case REQUEST(ACTION_TYPES.DELETE_YOUTUBELIVEVIDEO):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_YOUTUBELIVEVIDEO_LIST):
    case FAILURE(ACTION_TYPES.FETCH_YOUTUBELIVEVIDEO):
    case FAILURE(ACTION_TYPES.CREATE_YOUTUBELIVEVIDEO):
    case FAILURE(ACTION_TYPES.UPDATE_YOUTUBELIVEVIDEO):
    case FAILURE(ACTION_TYPES.DELETE_YOUTUBELIVEVIDEO):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_YOUTUBELIVEVIDEO_LIST): {
      const links = parseHeaderForLinks(action.payload.headers.link);

      return {
        ...state,
        loading: false,
        links,
        entities: loadMoreDataWhenScrolled(state.entities, action.payload.data, links),
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    }
    case SUCCESS(ACTION_TYPES.FETCH_YOUTUBELIVEVIDEO):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_YOUTUBELIVEVIDEO):
    case SUCCESS(ACTION_TYPES.UPDATE_YOUTUBELIVEVIDEO):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_YOUTUBELIVEVIDEO):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/youtube-live-videos';

// Actions

export const getEntities: ICrudGetAllAction<IYoutubeLiveVideo> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_YOUTUBELIVEVIDEO_LIST,
    payload: axios.get<IYoutubeLiveVideo>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IYoutubeLiveVideo> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_YOUTUBELIVEVIDEO,
    payload: axios.get<IYoutubeLiveVideo>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IYoutubeLiveVideo> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_YOUTUBELIVEVIDEO,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const updateEntity: ICrudPutAction<IYoutubeLiveVideo> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_YOUTUBELIVEVIDEO,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IYoutubeLiveVideo> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_YOUTUBELIVEVIDEO,
    payload: axios.delete(requestUrl),
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
